var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNotification(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.99925 0.744385C6.45215 0.744385 4.96842 1.35897 3.87446 2.45293C2.7805 3.54689 2.16592 5.03062 2.16592 6.57772V9.51772C2.16604 9.64699 2.13608 9.77452 2.07842 9.89022L0.647584 12.7511C0.577689 12.8908 0.544685 13.0461 0.551707 13.2022C0.558729 13.3584 0.605544 13.5101 0.687704 13.643C0.769865 13.7759 0.884644 13.8856 1.02114 13.9617C1.15763 14.0378 1.31132 14.0777 1.46758 14.0777H14.5309C14.6872 14.0777 14.8409 14.0378 14.9774 13.9617C15.1139 13.8856 15.2286 13.7759 15.3108 13.643C15.393 13.5101 15.4398 13.3584 15.4468 13.2022C15.4538 13.0461 15.4208 12.8908 15.3509 12.7511L13.9209 9.89022C13.863 9.77459 13.8327 9.64706 13.8326 9.51772V6.57772C13.8326 5.03062 13.218 3.54689 12.124 2.45293C11.0301 1.35897 9.54635 0.744385 7.99925 0.744385ZM7.99925 16.5777C7.48204 16.578 6.97748 16.4178 6.5551 16.1193C6.13272 15.8208 5.81332 15.3987 5.64092 14.9111H10.3576C10.1852 15.3987 9.86578 15.8208 9.4434 16.1193C9.02102 16.4178 8.51646 16.578 7.99925 16.5777Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotification);
export default __webpack_public_path__ + "static/media/notification.de18b4fd89afd2197345dde4435b2db6.svg";
export { ForwardRef as ReactComponent };